import React, { useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import { loadTemplateFile } from '../tools/layout-tool';
import { useAuth } from "../use-auth"

import { promiseFetchDataAuth } from 'crk-front-lib';
// eslint-disable-next-line no-unused-vars
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { ZetaGroup } from "../zeta-widget";

export function RenewPackage(props) {
  // const history = useHistory();
  const auth = useAuth();
  // console.info(auth);
  const [appTemplate, setAppTemplate] = useState([]);
  const [pkgProfile, setPkgProfile] = useState({
    app:{}
  });

  useEffect(() => {
    loadTemplateFile('member-renew', (result) => {
      setAppTemplate(result);
    })
  },[]);

  useEffect(() => {
    if (auth.config.storeApi) {
      promiseFetchDataAuth(`${auth.config.storeApi}/api/v2/member/subs/${auth.user.pkg_id}`)
      .then(result => {
        setPkgProfile({
          ...result,
          app_desc: result.app.app_desc,
          app_price: result.app.app_price,
          pkg_age: auth.user.pkg_age,
          pkg_expire: auth.user.pkg_expire,
          pkg_price: (result.app.app_price || 0) * (result.pkg_user_limit || 1),
        })
      })
      .catch((err) => {
        console.warn(err);
      })
    }
  }, [appTemplate, auth.config.storeApi, auth.user.pkg_age, auth.user.pkg_expire, auth.user.pkg_id]);

  return (
    <div className="row justify-content-center">
      <div className="col-xl-10 col-lg-12 col-md-9">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            {/* Nested Row within Card Body */}
            <div className="row p-3">
              <div className="col-lg-6 d-none d-lg-block bg-password-image"></div>
                <div className="col-lg-6">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-2">Package Status</h1>
                    <p className="mx-4 mb-4">สถานะการสมัครใช้งานโปรแกรม</p>
                  </div>
                  <form className="user" id="subscr">
                    <ZetaGroup template={appTemplate} data={pkgProfile} /*app={_this} onChange={handleChange}*/ />
                    {auth.user && auth.user.member_role && auth.user.member_role==='OWNER' && <React.Fragment> 
                    <button type="button" 
                      className="btn btn-primary btn-user w-40" 
                      onClick={() => {
                        window.crkStore.renew(auth.user.pkg_id);
                      }}>แจ้งต่ออายุ</button> &nbsp; &nbsp;
                    </React.Fragment>}
                    <button type="button" 
                      className="btn btn-primary btn-user w-40" 
                      onClick={() => {
                        window.crkStore.payment();
                      }}>แจ้งชำระเงิน</button> &nbsp; &nbsp;

                    <Link to="/dashboard">ใช้งานต่อ</Link>
                  </form>
              </div>
              {/* end right panel */}
            </div>
            {/* end of row */}
          </div>
        </div>
        {/* end of card */}
      </div>
    </div>
  )

  /*<div>
    <p>
      ช่วยต่ออายุ ด้วยครับ
    </p>
    <p>{auth.user.pkg_expire}</p>
    <button onClick={() => {
      window.crkStore.payment();
    }}>จ่ายเงิน</button> &nbsp; &nbsp;
    <Link to="/secure">ใช้งาน</Link>
  </div>
  */
}